import { defineComponent as _defineComponent } from 'vue'
import {ref, computed, watch, onMounted} from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Specifications',
  props: {
    attr: {
        type: Array,
        default: () => [],
    },
    show: {
        type: Boolean,
        default: false,
    },
},
  emits: ['update:show', 'confirm'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props



const data = ref<any[]>([]);


const isPickerShow = ref(false);
const pickerIdx = ref(0);
const pickerColumns = (str: string) => {
    return JSON.parse(str);
};
const confirmPicker = (val: any) => {
    data.value[pickerIdx.value].value = val.value;
    isPickerShow.value = false;
};
onMounted(() => {
    setData(props.attr);
});
const setData = (val: any) => {
    let specificationData = val.map((el: any) => {
        const {name, id, unit, attributeType} = el;
        let value: string | (string | number | null)[] = '';
        switch (attributeType) {
            case 'range':
                value = [];
                break;
            case 'select':
                value = '';
                break;
        }
        return {name, id, unit, value};
    });
    data.value = specificationData;
};

const confirm = () => {
    emit(
        'confirm',
        JSON.stringify(
            data.value.filter(el => {
                //@ts-ignore
                if (Array.isArray(el.value)) {
                    return el.value.length;
                } else {
                    return el.value;
                }
            }),
        ),
    );
    emit('update:show', false);
};

watch(
    () => props.attr,
    val => {
        setData(val);
    },
);

const __returned__ = { props, data, emit, isPickerShow, pickerIdx, pickerColumns, confirmPicker, setData, confirm, ref, computed, watch, onMounted }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})